import React, { ReactNode } from 'react';
import {
  NetworkId,
  WalletId,
  WalletManager,
  WalletProvider,
} from '@txnlab/use-wallet-react';
import { WalletUIProvider } from '@txnlab/use-wallet-ui-react';

// Create a wallet manager with supported wallets
const walletManager = new WalletManager({
  wallets: [
    WalletId.PERA,
    WalletId.DEFLY,
    WalletId.LUTE,
    WalletId.EXODUS,
    {
      id: WalletId.WALLETCONNECT,
      options: { 
        // This is a demo project ID - replace with your own in production
        projectId: 'fcfde0713d43baa0d23be0773c80a72b' 
      },
    },
  ],
  // Use mainnet for production
  defaultNetwork: NetworkId.MAINNET,
});

interface AlgorandWalletProviderProps {
  children: ReactNode;
}

export const AlgorandWalletProvider: React.FC<AlgorandWalletProviderProps> = ({ children }) => {
  return (
    <WalletProvider manager={walletManager}>
      <WalletUIProvider>{children}</WalletUIProvider>
    </WalletProvider>
  );
};